export const MAPA_PERIODOS_LABEL: Record<string, string> = {
	diario: 'Diário',
	mensal: 'Mensal',
	anual: 'Anual',
	anual_parcial: 'Anual parcial',
};

export function obterLabelPeriodo(periodo: string): string {
	if (!periodo) return '';
	return MAPA_PERIODOS_LABEL[periodo.toLowerCase()] || periodo;
}
